'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { DataSourceProps, ViewModelProps } from '../../types';

const ProductListViewModel = dynamic(() => import('../product-list-view-model'));

// View-model is dynamic-imported on the client. Props include:
//   - `initialAlgoliaData` — server-resolved Algolia search with the
//     user's `queryID`.
//   - `ctPromisesBySku` — per-SKU CT enrichment promises created (NOT
//     awaited) by the server tastic. Each tile awaits its own promise
//     under a Suspense boundary so prices stream in per tile.
const ProductListClientWrapper = (props: Omit<DataSourceProps, 'category'> & ViewModelProps) => {
  return <ProductListViewModel {...props} />;
};

export default ProductListClientWrapper;
